import { Classification } from '../types/ClassificationType';

import { CLASSIFICATIONS_LABELS } from '../constants/ClassificationsLabels';

export const convertClassificationKeyToTitle = (key: Classification) => {
    let title = '';
    title = CLASSIFICATIONS_LABELS[key];
    return title;
};
